import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

import withStyles from 'isomorphic-style-loader/withStyles';
import s from './BannerCaption.css';
import { Grid } from 'react-bootstrap';
import cx from 'classnames';
import Loader from '../../Loader';

const BannerCaption = ({ title, content }) => {
  if (!title || !content) {
    return <Loader type="text" />;
  }

  return (
    <Grid fluid>
      <div className={cx(s.bannerCaptionContainer)}>
        <h1 className={cx(s.noMargin, s.bannerCaptionText)}>
          <span className={s.bannerCaptionHighlight}>{title}</span> {content}
        </h1>
      </div>
    </Grid>
  );
};

BannerCaption.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
};

export default compose(
  withStyles(s),
)(BannerCaption);